import { jwtDecode } from 'jwt-decode';

import { logger } from 'utils/logger';

interface JWTPayload {
  exp: number;
  iat?: number;
  userId?: string;
  // Add other claims as needed
}

/**
 * Validates if a JWT token is still valid (not expired)
 * @param token - JWT token string to validate
 * @returns true if token is valid and not expired, false otherwise
 */
export const isTokenValid = (token: string): boolean => {
  try {
    const decoded = jwtDecode<JWTPayload>(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  } catch (error) {
    logger.error('Token validation error:', error);
    return false;
  }
};

/**
 * Gets the expiration time of a JWT token
 * @param token - JWT token string
 * @returns Expiration time in milliseconds, or null if token is invalid
 */
export const getTokenExpiration = (token: string): number | null => {
  try {
    const decoded = jwtDecode<JWTPayload>(token);
    return decoded.exp * 1000; // Convert to milliseconds
  } catch {
    return null;
  }
};
